/*
    "zip zips together arrays of equal length".

    E.g. zip([1, 2, 3], [a, b, c], [foo, bar, baz])
    = [[1, a, foo], [2, b, bar], [3, c, baz]]
*/
const zip = (rows) => rows[0].map((_, c) => rows.map((row) => row[c]));
export default zip;
